<template>
    <b-row>
        <b-col sm="12" md="12" lg="12" xl="12">
            <b-card no-body>
                <b-card-header>
                    <span class="h5">
                        ENTREGA -
                        <b-badge variant="warning">{{ operacao }}</b-badge>
                    </span>
                    <div class="float-right">
                        <slot name="botoes" v-bind="entrega"></slot>
                        <b-button
                            class="ml-2"
                            variant="primary"
                            @click.stop="mostrarTimeline()"
                            >{{ textoBtnTimeline }} Timeline</b-button
                        >
                    </div>
                    <historico
                        v-if="perfilGestor || perfilGerente || perfilUabs"
                        titulo="Histórico da Entrega"
                        :servicos="entregasServicos"
                        :id="entrega.entregaId"
                        class="ml-2 float-right"
                    ></historico>
                </b-card-header>
                <b-card-body>
                    <b-row>
                        <b-col sm="12" md="6">
                            <app-k-v
                                titulo="Descritivo"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                ><app-status
                                    v-if="entrega.manual"
                                    status="ENTREGA MANUAL"
                                ></app-status>
                                {{ entrega.descritivo }}</app-k-v
                            >

                            <app-k-v
                                titulo="Natureza"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                            >
                                <app-status
                                    :status="
                                        entrega.natureza ? entrega.natureza : ''
                                    "
                                ></app-status>
                            </app-k-v>

                            <app-k-v
                                titulo="Modalidade"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                            >
                                <app-status
                                    :status="entrega.modalidadeDescr"
                                ></app-status>
                            </app-k-v>

                            <app-k-v titulo="Status" :md="md" :lg="lg" :xl="xl">
                                <app-status
                                    :status="
                                        entrega.statusDescr
                                            ? entrega.statusDescr
                                            : ''
                                    "
                                ></app-status>
                                <app-entrega-detalhe-reprovacao
                                    :entrega="entrega"
                                    class="ml-1"
                                ></app-entrega-detalhe-reprovacao>
                            </app-k-v>
                            <app-k-v
                                titulo="Gestor Substituto"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="entrega.gestorSubstituto"
                                v-if="entrega.gestorSubstituto"
                            ></app-k-v>
                            <app-k-v
                                titulo="Valor Hora"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                            >
                                <strong>{{
                                    entrega.valorHora | currency
                                }}</strong>
                            </app-k-v>
                            <app-k-v
                                titulo="Previsão de Entrega"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="
                                    entrega.dataPrevisao
                                        ? $moment(entrega.dataPrevisao).format(
                                              'DD/MM/YYYY'
                                          )
                                        : ''
                                "
                            ></app-k-v>
                            <app-k-v
                                v-if="entrega.dataPrevisaoReprogramada"
                                titulo="Previsão Reprogramada"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                ><strong>
                                    {{
                                        entrega.dataPrevisaoReprogramada
                                            ? $moment(
                                                  entrega.dataPrevisaoReprogramada
                                              ).format('DD/MM/YYYY')
                                            : ''
                                    }}
                                </strong>
                                <btn-justificativa-data-previsao-reprogramada
                                    :entrega="entrega"
                                >
                                </btn-justificativa-data-previsao-reprogramada
                            ></app-k-v>
                            <app-k-v
                                titulo="Carga Horária Prevista"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="entrega.cargaHorariaPrevista"
                            ></app-k-v>
                            <app-k-v
                                titulo="Valor Total Previsto"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                            >
                                <strong>{{
                                    entrega.valorTotalPrevisto | currency
                                }}</strong>
                            </app-k-v>
                        </b-col>
                        <b-col sm="12" md="6">
                            <app-k-v
                                titulo="Evento"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                v-if="entrega.codEvento"
                            >
                                <strong>{{ entrega.codEvento }}</strong>
                                <entrega-atualizar-evento
                                    :entrega="entrega"
                                    :entregasServicos="entregasServicos"
                                    @obterAtualizacao="
                                        $emit('obterAtualizacao')
                                    "
                                    v-if="perfilGestor"
                                ></entrega-atualizar-evento>
                            </app-k-v>
                            <app-k-v
                                titulo="Evento"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                v-if="entrega.eventoEspecial"
                            >
                                <strong>ESPECIAL</strong>
                                <entrega-atualizar-evento
                                    :entrega="entrega"
                                    :entregasServicos="entregasServicos"
                                    @obterAtualizacao="
                                        $emit('obterAtualizacao')
                                    "
                                    v-if="perfilGestor"
                                ></entrega-atualizar-evento>
                            </app-k-v>
                            <app-k-v
                                titulo="Justificativa Evento"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                v-if="entrega.eventoEspecial"
                                :dado="entrega.justificativaEvento"
                            >
                            </app-k-v>
                            <app-k-v
                                titulo="Realização"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="
                                    entrega.dataEntrega
                                        ? $moment(entrega.dataEntrega).format(
                                              'DD/MM/YYYY'
                                          )
                                        : ''
                                "
                            ></app-k-v>
                            <app-k-v
                                titulo="Carga Horária Entregue"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="entrega.cargaHorariaEntregue"
                            ></app-k-v>
                            <app-k-v
                                titulo="Valor Total Entregue"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                            >
                                <strong>{{
                                    entrega.valorTotalEntregue | currency
                                }}</strong>
                            </app-k-v>
                            <app-k-v
                                titulo="Justific. Divergência"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="entrega.justificativaDivergencia"
                                v-if="entrega.justificativaDivergencia"
                            ></app-k-v>
                            <app-k-v
                                titulo="Comprometimento"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                            >
                                <entrega-comprometimento
                                    :entrega="entrega"
                                    :movimentosServicos="movimentosServicos"
                                    @obterAtualizacao="
                                        $emit('obterAtualizacao')
                                    "
                                ></entrega-comprometimento>
                            </app-k-v>
                            <entrega-cancelamento
                                :entrega="entrega"
                            ></entrega-cancelamento>
                            <app-k-v
                                titulo="Protocolo de Pagamento"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="entrega.registroPagamento"
                                v-if="entrega.registroPagamento"
                            ></app-k-v>
                            <app-k-v
                                titulo="Atualizado em"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="
                                    entrega.dataAtualizacao
                                        ? $moment(
                                              entrega.dataAtualizacao
                                          ).format('DD/MM/YYYY HH:mm')
                                        : ''
                                "
                            ></app-k-v>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <entrega-time-line
                                :entregasServicos="entregasServicos"
                                :entrega="entrega"
                                v-if="exibirTimeline"
                            ></entrega-time-line>
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import EntregaDetalheReprovacao from './EntregaDetalheReprovacao'
import EntregaComprometimento from './EntregaComprometimento'
import EntregaAtualizarEvento from './EntregaAtualizarEvento'
import EntregaCancelamento from './EntregaCancelamento'
import BtnJustificativaDataPrevisaoReprogramada from './BtnJustificativaDataPrevisaoReprogramada'
import EntregaTimeLine from './EntregaTimeLine'
import Historico from '../../../../shared/components/Historico'

export default {
    props: {
        entrega: {
            type: Object,
            default: () => ({})
        },

        movimentosServicos: {
            type: Object,
            default: () => ({})
        },

        entregasServicos: {
            type: Object,
            default: () => ({})
        },

        perfilGestor: {
            type: Boolean,
            default: () => false
        },

        perfilUabs: {
            type: Boolean,
            default: () => false
        },

        perfilGerente: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            operacao: 'DETALHAR',
            xl: 3,
            lg: 3,
            md: 3,
            textoBtnTimeline: 'Exibir',
            exibirTimeline: false
        }
    },

    methods: {
        mostrarTimeline() {
            this.exibirTimeline = !this.exibirTimeline
            if (!this.exibirTimeline) {
                this.textoBtnTimeline = 'Exibir'
            } else {
                this.textoBtnTimeline = 'Ocultar'
            }
        }
    },

    components: {
        AppEntregaDetalheReprovacao: EntregaDetalheReprovacao,
        EntregaComprometimento,
        EntregaAtualizarEvento: EntregaAtualizarEvento,
        EntregaCancelamento: EntregaCancelamento,
        BtnJustificativaDataPrevisaoReprogramada,
        EntregaTimeLine,
        Historico
    },

    computed: {}
}
</script>
